<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break" id="auto_bookmark_toc_1"><span><span class="calibre2">For John B, as ever.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?0eaf4186